import { render } from "./Backtest.vue?vue&type=template&id=5b347708&scoped=true"
import script from "./Backtest.vue?vue&type=script&lang=js"
export * from "./Backtest.vue?vue&type=script&lang=js"

import "./Backtest.vue?vue&type=style&index=0&id=5b347708&lang=scss&scoped=true"

import exportComponent from "D:\\Microsoft VS Code Project\\startkit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b347708"]])

export default __exports__